import { Button, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';

import './ClaimCardButton.scss';

interface Props {
    rtl: boolean;
    amount: string;
    claimPromo?: any;
    commitmentPeriod: string;
    claimButtonEnable?: any;
    handleClaim: (value: string) => void;
}

function ClaimCardButton({ rtl, handleClaim, amount, claimPromo, commitmentPeriod, claimButtonEnable }: Props) {

    const { t } = useTranslation();

    return (
        <div className='ClaimCard__Button'>
            <div className='CCB__section'>
                <div className='CCB__commiments'>
                    <Typography rtl={rtl} className='CCB__Amount'>{amount} {t('SAR')}</Typography>
                    <Typography rtl={rtl} className='CCB__Months'>{commitmentPeriod} {t('Months_commitment')}</Typography>
                </div>
                <Button
                    rtl={rtl}
                    className='CCB__Btn'
                    onClick={() => handleClaim(claimPromo)}
                    variant={claimButtonEnable ? 'default' : 'disabled'}
                >
                    {t('Claim')}
                </Button>
            </div>
        </div>
    )
}

export default ClaimCardButton